import { LitElement, html } from './-global.min.js'

class HHWishlistButton extends LitElement {
  static properties = {
    _hasWishlists: {
      state: true,
    },
  }

  constructor() {
    super()

    this._hasWishlists = false
  }

  connectedCallback() {
    super.connectedCallback()

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = []
    }

    window.SwymCallbacks.push(this.swymCallbackFn.bind(this))

    document.addEventListener(
      'wishlist-item:updated',
      this.handleGlobalWishlistUpdate.bind(this)
    )
  }

  swymCallbackFn(swat) {
    swat.fetchWrtEventTypeET((products) => {
      this._hasWishlists = products.length > 0

      this.setActiveState(this._hasWishlists)
    }, 4)
  }

  handleGlobalWishlistUpdate() {
    this.swymCallbackFn(window._swat)
  }

  setActiveState(hasItems) {
    if (hasItems) {
      this.setAttribute('has-items', '')
    } else {
      this.removeAttribute('has-items')
    }
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-wishlist-nav-link', HHWishlistButton)
